import axios from "axios";
import Cookies from "js-cookie";

const authInterceptor = (config) => {
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get("token");

  const tokenFromCookie = Cookies.get("halasat-ftth-token-1");

  const token = tokenFromUrl || tokenFromCookie;

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  config.headers["app-version"] = "1.3";

  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname + window.location.search;
      Cookies.remove("halasat-ftth-token-1");

      if (!currentPath.includes("/login")) {
        window.location.href = `/login?redirect_url=${encodeURIComponent(
          currentPath,
        )}`;
      }
    }
    return Promise.reject(error);
  },
);

export default api;
